import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllActiveHotels = createAsyncThunk(
  "Hotels/HotelsListForWebsite",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Hotels/HotelsListForWebsite`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Hotels:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllHotelCities = createAsyncThunk(
  "Hotels/CityListForWebsite",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Hotels/CityListForWebsite`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Hotel Cities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveCities = createAsyncThunk(
  "City/FindAllActiveCity",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/City/FindAllActiveCity`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Cities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHotelByURL = createAsyncThunk(
  "Hotels/FindByURLHotels",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Hotels/FindByURLHotels`,
        { URL: URL },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Hotels:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertWeblInquiry = createAsyncThunk(
  "Inquiry/InsertInquiry",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Inquiry/InsertInquiry`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error inserting inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHotelSpecialRate = createAsyncThunk(
  "HotelSpecialRate/GetHotelSpecialRate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/HotelSpecialRate/GetHotelSpecialRate`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error get Hotel Rate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getLiveVisitorCount = createAsyncThunk(
  "GoogleContacts/visitors",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/GoogleContacts/visitors`,
      );
      return response.data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get Visitorcount:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// ─── SERVER (native fetch — call ONLY from Server Components / page.tsx) ────

export async function fetchAllActiveHotels(formData: any) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Hotels/HotelsListForWebsite`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...formData }),
      next: { revalidate: 300 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export async function fetchHotelByURL(URL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Hotels/FindByURLHotels`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ URL: URL }),
      next: { revalidate: 300 },
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}
